<template>
  <div class="header">
    <header>
      <a href="/" title="Contrology home page" class="logo-link">
        <img src="@/assets/logo-contrology@1x.png" srcset="@/assets/logo-contrology@2x.png 2x" alt="Contrology logo" class="logo">
      </a>
      <div class="flex-right">
        <nav class="main-nav">
          <div class="nav-item">
            <a>Shop</a>
            <nav class="sub-nav sub-nav-row">
              <div class="sub-nav-col">
                <!-- <p class="sub-nav-title">Apparatus</p> -->
                <router-link to="/reformer">Reformer</router-link>
                <router-link to="/cadillac">Cadillac</router-link>
                <router-link to="/reformer-tower">Reformer with Tower</router-link>
                <router-link to="/ladder-barrel">Ladder Barrel</router-link>
                <router-link to="/small-barrel">Small Barrel</router-link>
                <router-link to="/wunda-chair"><span>Wunda Chair</span></router-link>
                <router-link to="/arm-chair">Arm Chair</router-link>
                <router-link to="/ped-o-pul">Ped-o-Pul</router-link>
                <router-link to="/folding-mat">Folding Mat</router-link>
              </div>
              <div class="sub-nav-col">
                <router-link to="/wall-tower">Wall Tower</router-link>
                <router-link to="/high-mat">High Mat</router-link>
                <router-link to="/spine-corrector">Spine Corrector</router-link>
                <router-link to="/accessories/Springs">Springs</router-link>
                <router-link to="/accessories/Handles">Handles</router-link>
                <router-link to="/accessories">Accessories</router-link>
                <router-link to="/apparel">Apparel</router-link>
                <router-link to="/accessories/Books">Books</router-link>
                <!-- <a href="https://balancedbodyinc.typeform.com/to/xTg7rwdw" target="_blank">Wunda Chair Waitlist</a> -->
              </div>
            </nav>
          </div>
          <div class="nav-item">
            <a>Community</a>
            <nav class="sub-nav">
              <router-link to="/demo-centers">Authorized Demo Centers</router-link>
              <router-link to="/trainings">Classical Training Programs</router-link>
              <router-link to="/events">Events</router-link>
              <router-link to="/event-videos">Event Recordings</router-link>
              <router-link to="/joe-gym">Joe's Gym</router-link>
              <router-link to="/resources">Resources</router-link>
              <!-- <router-link to="/online-courses">Online Classes</router-link> -->
            </nav>
          </div>
          <div class="nav-item">
            <router-link to="/about">About</router-link>
          </div>
          <div class="nav-item">
            <router-link to="/support">Support</router-link>
          </div>
        </nav>
        <!-- <form id="form">
          <div class="flex-wrap">
            <span class="sign-up">Sign Up for Contrology News!</span>
            <label for="email" class="off-screen">Email address</label>
            <input
              type="email"
              placeholder="Email Address"
              name="emailaddress"
              v-model="emailaddress"
            />
            <input
              type="submit"
              value="Sign Up"
              :disabled="disabled"
              @click.prevent="submitForm"
            />
          </div>
          <span v-show="message" class="err">{{ message }}</span>
        </form> -->
      </div>
    </header>
    <Slide width="330">
      <!-- <form>
        <div class="sign-up">Sign Up for Contrology News!</div>
        <div class="flex-wrap">
          <label for="email" class="off-screen">Email address</label>
          <input
            type="email"
            placeholder="Email Address"
            name="emailaddress"
            v-model="emailaddress"
            @click.stop
          />
          <input
            type="submit"
            value="Sign Up"
            :disabled="disabled"
            @click.prevent.stop="submitForm"
          />
        </div>
        <div v-show="message" class="err">{{ message }}</div>
      </form> -->
      <a>
        <span>Shop</span>
      </a>
      <nav class="sub-nav">
        <a href="/reformer"><span>Reformer</span></a>
        <a href="/cadillac"><span>Cadillac</span></a>
        <a href="/reformer-tower"><span>Reformer with Tower</span></a>
        <a href="/ladder-barrel"><span>Ladder Barrel</span></a>
        <a href="/small-barrel"><span>Small Barrel</span></a>
        <a href="/wunda-chair"><span>Wunda Chair</span></a>
        <a href="/arm-chair"><span>Arm Chair</span></a>
        <a href="/ped-o-pul"><span>Ped-o-Pul</span></a>
        <a href="/folding-mat"><span>Folding Mat</span></a>
        <a href="/wall-tower"><span>Wall Tower</span></a>
        <a href="/high-mat"><span>High Mat</span></a>
        <a href="/spine-corrector"><span>Spine Corrrector</span></a>
        <a href="/accessories/Springs"><span>Springs</span></a>
        <a href="/accessories/Handles"><span>Handles</span></a>
        <a href="/accessories"><span>Accessories</span></a>
        <a href="/apparel"><span>Apparel</span></a>
        <a href="/accessories/Books"><span>Books</span></a>
        <!-- <a href="https://balancedbodyinc.typeform.com/to/xTg7rwdw" target="_blank"><span>Wunda Chair Waitlist</span></a> -->
      </nav>
      <a href="#">
        <span>Community</span>
      </a>
      <nav class="sub-nav">
        <router-link to="/demo-centers">Authorized Demo Centers</router-link>
        <router-link to="/trainings">Classical Training Programs</router-link>
        <router-link to="/events">Events</router-link>
        <router-link to="/event-videos">Event Recordings</router-link>
        <router-link to="/joe-gym">Joe's Gym</router-link>
        <router-link to="/resources">Resources</router-link>
      </nav>
      <a href="/about">
        <span>About</span>
      </a>
      <a href="/support">
        <span>Support</span>
      </a>
    </Slide>
  </div>
</template>

<script>
import { Slide } from 'vue-burger-menu'

  export default {
    name: 'appheader',

    components: {
      Slide
    },
  }
</script>

<style lang="scss" scoped>
header {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 3%;
  height: 120px;
}

.logo {
  width: 240px;
}

.flex-right {
  display: none;
}

::v-deep .bm-item-list .sub-nav {
  display: flex;
  flex-flow: column nowrap;
  font-size: 1.125rem;
  line-height: 2.5;
  padding-left: 24px;
  margin-top: -20px;
}

::v-deep .bm-item-list .sub-nav a {
  color: var(--black);
  text-decoration: none;
}

::v-deep .bm-burger-button {
  top: 20px;
  left: 20px;
}

::v-deep .line-style {
  height: 10%;
}

::v-deep .line-style:nth-of-type(2) {
  width: 26px;
}

::v-deep .bm-menu {
  background-image: url(https://s3.amazonaws.com/s3.pilates.com/img/landing-pages/contrology/sandpaper.png);
}

::v-deep .bm-item-list {
  margin-right: 7%;
  margin-left: 7%;
}

::v-deep .bm-item-list > a {
  border-top: 1px solid var(--black);
}

::v-deep .bm-item-list > a:last-of-type {
  border-bottom: 1px solid var(--black);
}

::v-deep .bm-item-list > * > span {
  color: var(--black);
  font-family: var(--bryant);
  text-transform: uppercase;
  font-weight: 500;
  font-size: 1.5625rem;
}

::v-deep .bm-cross {
  background: var(--black);
}

.bm-item-list form {
  flex-flow: column nowrap;
}

.flex-wrap {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
}

.off-screen {
  left: -100vw;
  position: absolute;
}

@media only screen and (min-width: 1024px) {
  header {
    justify-content: space-between;
  }

  ::v-deep .bm-burger-button {
    display: none;
  }

  .logo {
    margin-left: 10px;
  }

  .flex-right {
    display: flex;
    flex-flow: column nowrap;
    align-items: flex-end;
  }

  input[type=email] {
    border-radius: 0;
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
    border-right: none;
    margin-right: 0;
  }

  input[type=submit] {
    border-radius: 0;
    border-top-right-radius: 3px;
    border-bottom-right-radius: 3px;
  }

  .main-nav {
    display: flex;
    font-family: var(--bryant);
    font-weight: 500;
    font-size: 1.375rem;
    line-height: 2;
    text-transform: uppercase;
  }

  .main-nav a {
    color: var(--black);
    text-decoration: none;
  }

  .main-nav a[href]:hover {
    text-decoration: underline;
  }

  .nav-item {
    position: relative;
    display: block;
    padding: 0 15px;
  }

  .sub-nav {
    position: absolute;
    z-index: 10000;
    top: 44px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    flex-flow: column nowrap;
    width: auto;
    font-family: var(--roboto);
    font-size: 0.875rem;
    line-height: 2.75;
    font-weight: 400;
    background-color: rgba(0, 0, 0, 0.7);
    text-transform: none;
    padding: 25px 30px;
    display: none;
  }

  .sub-nav a {
    white-space: nowrap;
    color: var(--white);
  }

  .sub-nav::before {
    content:'';
    position: absolute;
    top: -10px;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 9px solid transparent;
    border-right: 9px solid transparent;
    border-bottom: 10px solid rgba(0, 0, 0, 0.7);
  }

  .nav-item:hover .sub-nav {
    display: flex;
  }

  .sub-nav-row {
    flex-direction: row;
  }

  .sub-nav-col {
    display: flex;
    flex-direction: column;
    margin-right: 40px;
  }

  .sub-nav-col:last-of-type {
    margin-right: 0;
  }

  .sub-nav-title {
    font-weight: 700;
    text-transform: uppercase;
    margin: 0;
    color: #fff;
    width: 120px;
    letter-spacing: 0.5px;
  }
}
</style>
